import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import FreeTierContent from './FreeTierContent';
import useOrganizationAllowedMedicalProfileUsage from '../../../../../../hooks/api/useOrganizationAllowedMedicalProfileUsage';
import PaidTab from './PaidTab';

export type BillingTabOwnProps = {};

export type BillingTabProps = BillingTabOwnProps;

const BillingTab: React.FC<BillingTabProps> = () => {
    const { isLoading, allowedProfileUsage } = useOrganizationAllowedMedicalProfileUsage();

    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (allowedProfileUsage?.type !== 'limited' ? <PaidTab /> : <FreeTierContent />)}
        </AnimateLoadedContent>
    );
};

export default React.memo(BillingTab);
